import { render, staticRenderFns } from "./update_payment_event_card.vue?vue&type=template&id=4582738f&"
import script from "./update_payment_event_card.vue?vue&type=script&lang=js&"
export * from "./update_payment_event_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports